import script from "./TradingDashboardScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./TradingDashboardScreen.vue?vue&type=script&setup=true&lang=js"

import "./TradingDashboardScreen.vue?vue&type=style&index=0&id=4f488fbf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f488fbf"]])

export default __exports__